export default __webpack_public_path__ + "static/media/pDawn-plasmid.1d013169.svg";